<template>
    <div>
        <div class="text-center">
            <h2>Δημήτριος Σάββας</h2>
        </div>
        <v-container class="main-text text-container">
            <div>
                <v-img :width="415" :height="415" style="float: left;" class="bradius" :src="require('@/assets/partners/Photo-D-Savvas.jpg')" />
                <p class="cv-text">
                    Ο Δημήτρης Σάββας είναι Καθηγητής στο Τµήµα Επιστήμης Φυτικής Παραγωγής του Γεωπονικού Πανεπιστημίου Αθηνών. Έχει λάβει πτυχίο γεωπόνου στην ειδικότητα της Φυτοτεχνίας από τη Γεωπονική Σχολή Αθηνών το 1985 και διδακτορικό δίπλωμα από τη Γεωπονική Σχολή του Πανεπιστημίου της Βόννης (Γερμανία) με ειδίκευση στις Κηπευτικές Καλλιέργειες και την Υδροπονία το 1992. Μετά την απονομή του διδακτορικού διπλώματος εργάστηκε ως έκτακτο εκπαιδευτικό προσωπικό στα ΤEI Μεσολογγίου, Καλαμάτας, και Ηπείρου αλλά και στο Πανεπιστήμιο Ιωαννίνων. Επίσης, διδάσκει ως επισκέπτης καθηγητής στο μεταπτυχιακό πρόγραμμα του MAICh-CIHEAM από το 2000 συνεχώς μέχρι και το 2022. Στο Γεωπονικό Πανεπιστήμιο Αθηνών υπηρετεί από τον Ιούνιο του 2006, αρχικά ως επίκουρος καθηγητής, από το 2011 ως αναπληρωτής καθηγητής και από το 2015 ως καθηγητής. Από το 2016 είναι Διευθυντής του Εργαστηρίου Κηπευτικών Καλλιεργειών του ΓΠΑ. Από το 2012 έως το 2016 διετέλεσε εσωτερικό μέλος του Συμβουλίου του ΓΠΑ, ενώ από 1/1/2019 είναι Κοσμήτορας της Σχολής Επιστημών των Φυτών του ΓΠΑ. Από το 2017 έως το 2020 διετέλεσε επίσης Διευθυντής του Προγράμματος Μεταπτυχιακών Σπουδών του Τμήματος Επιστήμης Φυτικής Παραγωγής. Στα κύρια ερευνητικά του ενδιαφέροντα περιλαμβάνονται θέματα σχετικά με τις σύγχρονες τεχνολογίες και την ορθολογική διαχείριση των φυσικών πόρων στις θερμοκηπιακές καλλιέργειες, το μικροκλίμα του θερμοκηπίου, την θρέψη και λίπανση των κηπευτικών, τις υδροπονικές καλλιέργειες και τα υποστρώματα, την άρδευση, καθώς και τον εμβολιασμό των κηπευτικών. Το συγγραφικό του έργο περιλαμβάνει πάνω από 120 εργασίες δημοσιευμένες σε έγκριτα διεθνή επιστημονικά περιοδικά με κριτές που διαθέτουν impact factor στο Journal Citation Reports, πάνω από 50 επιστημονικές εργασίες σε πλήρη πρακτικά διεθνών συνεδρίων, πάνω από 60 εργασίες σε πλήρη πρακτικά πανελληνίων συνεδρίων, 5 κεφάλαια σε ξενόγλωσσα βιβλία και 3 πανεπιστημιακά συγγράμματα (Γενική Λαχανοκομία, Καλλιέργειες εκτός Εδάφους, Γενική Ανθοκομία) στα Ελληνικά. Σύμφωνα με πρόσφατη ταξινόμηση που διενήργησε το Stanford University για τον εκδοτικό οίκο Elsevier, ο καθηγητής Δ. Σάββας κατατάσσεται στο κορυφαίο 2% των επιστημόνων διεθνώς στο επιστημονικό του υποπεδίο. Έχει συμμετάσχει ή συμμετέχει ως μέλος της Ερευνητικής Ομάδας ή συντονιστής σε πολλά ευρωπαϊκά και εθνικά ερευνητικά προγράμματα σχετικά με τις κηπευτικές καλλιέργειες. Από το 2010 μέχρι σήμερα έχει συντονίσει ή συντονίζει την ερευνητική ομάδα του ΓΠΑ σε 4 ευρωπαϊκά ερευνητικά προγράμματα και ειδικότερα στο LEGUME FUTURES (FP7, 2010-2014), στο EUROLEGUME (FP7, 2014-2017), στο TRUE (H2020, 2017-2021) και στο TOMRES (H2020, 2017-2020), ενώ από 1/10/2019 συντονίζει και το Ευρωπαϊκό ερευνητικό πρόγραμμα VEGADAPT (PRIMA). Από το 2022 είναι ο γενικός συντονιστής της Ερευνητικής Ομάδας του ΓΠΑ αλλά και ολόκληρης της κοινοπραξίας στο ευρωπαϊκό ερευνητικό πρόγραμμα ECONUTRI (HORIZON EUROPE, 2022-2026) η οποία περιλαμβάνει 24 εταίρους από την Ευρώπη και 6 από την Κίνα με συνολικό προϋπολογισμό 6.000.000 €. Από την 1/1/2020 συντονίζει επίσης το ερευνητικό πρόγραμμα NUTRISENSE που χρηματοδοτείται από το ΕΛΙΔΕΚ, ενώ συμμετέχει ως μέλος της Ε.Ο του ΓΠΑ και στο ευρωπαϊκό ερευνητικό πρόγραμμα RADIANT του HORIZON2020 (2021-2025). Ένα πλήρες βιογραφικό σημείωμα του Καθηγητή Δημήτρη Σάββα είναι διαθέσιμο μέσω του συνδέσμου:
                    <a href="http://www.ekk.aua.gr/index.php?sec=members&item=4&doc=2" target="_blank">http://www.ekk.aua.gr/index.php?sec=members&item=4&doc=2</a>).
                </p>
            </div>
        </v-container>
    </div>
</template>

<script>
    export default {
        name: 'App',
        components: {
        },
        data: () => ({
        }),
        computed: {
        }
    }
</script>
<style scoped>
.cv-card {
    border: 1px solid #D9D9D9;
    border-radius: 25px;
    text-align: center;
}
.bradius {
    border-radius: 25px;
    margin-right: 15px;
}
.cv-text {
    display: inline;
}
.main-text {
    width: 90%;
    max-width: 900px;
    margin: auto;
    color: #646464;
}

@media (max-width: 600px) {
    .bradius {
        float: none !important;
        display: block;
        margin: 0 auto 15px !important;
        max-width: 280px;
    }
}
</style>
